import 'core-js/features/object/values';
import HomePageRevision from 'api/home-page-revision';
import FileUpload from 'lib/file-upload';
import constants from 'constants/home-page-revision';

export const setHomePageRevision = (revision) => (dispatch) => {
  // Bug found while upgrading to React v18
  dispatch({
    type: constants.SET_HOME_PAGE_REVISION,
    revision: {
      id: revision.id,
      meta: revision.sections.meta,
      sections: revision.sections.sections,
      published: revision.published,
      updatedAt: revision.updatedAt,
      oldHomePageId: revision.oldHomePageId,
    },
  });
};

export const saveHomePageRevision =
  (isPublished = false) =>
  async (dispatch, getState) => {
    const published =
      getState().homePageRevision.revision.published || isPublished;

    dispatch({
      type: constants.SAVE_HOME_PAGE_REVISION_REQUEST,
    });

    const homePageRevision = new HomePageRevision({
      sections: {
        meta: getState().homePageRevision.revision.meta,
        sections: getState().homePageRevision.revision.sections,
      },
      published,
    });

    try {
      const response = await homePageRevision.save();

      dispatch({
        type: constants.SAVE_HOME_PAGE_REVISION_SUCCESS,
        id: response.id,
        meta: response.sections.meta,
        sections: response.sections.sections,
        published: response.published,
      });
    } catch (response) {
      dispatch({
        type: constants.SAVE_HOME_PAGE_REVISION_FAILURE,
        errorMessage:
          response.message || response.statusText || response.status,
        errors: homePageRevision.errors.extract(),
      });
    }
  };

export const updateSectionTheme = (key, value, sectionId) => {
  return {
    type: constants.UPDATE_HOME_PAGE_REVISION_SECTION_THEME,
    key,
    value,
    sectionId,
  };
};

export const updateSectionData = (key, value, sectionId, index = 0) => {
  return {
    type: constants.UPDATE_HOME_PAGE_REVISION_SECTION_DATA,
    key,
    value,
    sectionId,
    index,
  };
};

export const addSectionData = (sectionId, tabId) => {
  return {
    type: constants.ADD_HOME_PAGE_REVISION_SECTION_DATA,
    sectionId,
    tabId,
  };
};

export const deleteSectionData = (sectionId, index = 0) => {
  return {
    type: constants.DELETE_HOME_PAGE_REVISION_SECTION_DATA,
    sectionId,
    index,
  };
};

export const updateSectionMeta = (key, value, sectionId) => {
  return {
    type: constants.UPDATE_HOME_PAGE_REVISION_SECTION_META,
    key,
    value,
    sectionId,
  };
};

export const addSection = (position, sectionContent) => {
  return {
    type: constants.ADD_NEW_HOME_PAGE_REVISION_SECTION,
    position,
    sectionContent,
  };
};

export const setCurrentSectionId = (id) => {
  return {
    type: constants.SET_HOME_PAGE_REVISION_CURRENT_SECTION_ID,
    id,
  };
};

export const showTemplatesDrawer = (value) => {
  return {
    type: constants.SHOW_HOME_PAGE_TEMPLATES_DRAWER,
    value,
  };
};

export const showAddNewSectionDrawer = (value) => {
  return {
    type: constants.SHOW_HOME_PAGE_ADD_NEW_SECTIONS_DRAWER,
    value,
  };
};

export const deleteSection = (position) => {
  return {
    type: constants.DELETE_HOME_PAGE_REVISION_SECTION,
    position,
  };
};

export const selectTemplate = (sections, templateId, meta) => {
  return {
    type: constants.SELECT_HOME_PAGE_REVISION_TEMPLATE,
    sections,
    templateId,
    meta,
  };
};

export const updateTemplateMeta = (key, value) => {
  return {
    type: constants.UPDATE_HOME_PAGE_REVISION_TEMPLATE_META,
    key,
    value,
  };
};

export const uploadFile = (file) => async (dispatch) => {
  dispatch({
    type: constants.UPLOAD_HOME_PAGE_REVISION_IMAGE_REQUEST,
  });

  try {
    const imageUrl = await FileUpload.perform(file);

    dispatch({
      type: constants.UPLOAD_HOME_PAGE_REVISION_IMAGE_SUCCESS,
      imageUrl,
    });
  } catch (response) {
    dispatch({
      type: constants.UPLOAD_HOME_PAGE_REVISION_IMAGE_FAILURE,
      errorMessage: response.statusText || response.status,
    });
  }
};

export const moveSection = (fromIndex, position) => (dispatch, getState) => {
  const sections = [...getState().homePageRevision.revision.sections];
  const toIndex = position === 'before' ? fromIndex - 1 : fromIndex + 1;
  const element = sections[fromIndex];

  sections.splice(fromIndex, 1);
  sections.splice(toIndex, 0, element);

  dispatch({
    type: constants.MOVE_HOME_PAGE_REVISION_SECTION,
    sections,
    toIndex,
  });
};

export const reorderHomepageItems =
  (newOrder, sectionId) => async (dispatch, getState) => {
    const sectionData =
      getState().homePageRevision.revision.sections[sectionId].data;
    const newIndexOrder = Object.values(newOrder);
    const sortedData = newIndexOrder.map((i) => sectionData[i]);

    dispatch({
      type: constants.REORDER_HOME_PAGE_ITEMS,
      data: sortedData,
      sectionId,
    });
  };

export const changeHomePageSectionKey = (key) => {
  return {
    type: constants.CHANGE_HOME_PAGE_SECTION_KEY,
    key,
  };
};

export const updateHomePageRevision = (key, value) => {
  return {
    type: constants.UPDATE_HOME_PAGE_REVISION,
    key,
    value,
  };
};

export const updateHomePageRevisionNonce = (value) => {
  return {
    type: constants.UPDATE_HOME_PAGE_REVISION_NONCE,
    value,
  };
};
